import request from '@/utils/request'

export async function fetchMaintenance() {
  /* BE must respond: { maintenanceFlag: Boolean, frontendVersion: String } */
  return request.get('/maintenance')
} 


// WEBPACK FOOTER //
// ./src/api/maintenance.js